export const InstanceIcon = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2172_1861)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.49996 12.8332L1.66663 6.99984L7.49996 1.1665L13.3333 6.99984L7.49996 12.8332ZM11.6834 6.99984L7.49996 2.81642L3.31654 6.99984L7.49996 11.1833L11.6834 6.99984Z"
        fill="#9747FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_2172_1861">
        <rect width="14" height="14" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
